import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class HaRolemanagementserviceService {
  constructor(private http: HttpClient) {
  }

  getRoles() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Role/getRoles');
  }

  insertRole(text, roleMasterId) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Role/insertRole', { text: text, roleMasterId: roleMasterId });
  }

  getMenuItems(roleId) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Role/getMenuItems?roleId=' + roleId );
  }

  insertSelectedMenuItems(roleId, menuItemId, isChecked) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Role/insertSelectedMenuItems', { roleId: roleId,menuItemId: menuItemId,isChecked:isChecked });
  }

  getUsersByRole(roleId, pageNo, text) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Role/getUsersByRole?roleId=' + roleId + '&pageNo=' + pageNo + '&text=' + text);
  }

  getUsersNotInAnyRole() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Role/getUsersNotInAnyRole');
  }

  activateUserRole(userId, roleId) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Role/activateUserRole', { userId: userId, roleId: roleId });
  }

}
